import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/abhi/Documents/Knowt.nosync/Goliath/apps/web/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/abhi/Documents/Knowt.nosync/Goliath/apps/web/features/Profile/ProfilePage/ProfilePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/Users/abhi/Documents/Knowt.nosync/Goliath/node_modules/swr/dist/index/config-client-Bi4rgVRk.mjs");
